import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import spinnerReducer from "./redux/spinnerSlice";
import languageReducer from "./redux/languageSlice";

const rootReducer = combineReducers({ spinner: spinnerReducer, language: languageReducer });

export type RootState = ReturnType<typeof rootReducer>;

const store = configureStore({
  reducer: rootReducer,
});

export default store;
